<template>
  <div class="mainMonitor">
    <div class="leftContain">
      <transition name="moveL">
        <!-- 用户列表 -->
        <div class="treeContain" v-show="show">
          <NewTree :showTree="true" @formatData="formatData"></NewTree>
        </div>
      </transition>
      <NewMenu
        :isDefault="isDefault"
        :theme="theme"
        :onlinePersons="onlinePersons"
        :mapMenuData="mapMenuData"
        @openFencePan="openFencePan"
      ></NewMenu>
    </div>
    <!-- 右边历史记录弹窗 -->
    <div class="rightContain" v-if="pointOpenItem.userId && helmetType !== 0" v-show="isPlayTrack">
      <transition name="moveR">
        <div class="historyContain" v-show="show">
          <NewHistory :isPack.sync="isPack" :helmetType="helmetType" :historyData="formatDataItem"></NewHistory>
        </div>
      </transition>
    </div>
    <!-- 右边H5历史记录弹窗 -->
    <div class="rightContain" v-if="pointOpenItem.userId && helmetType === 0" v-show="jlsTrackList">
      <transition name="moveR">
        <div class="historyContain" v-show="show">
          <NewHistory :isPack.sync="isPack" :helmetType="helmetType" :historyData="formatDataItem"></NewHistory>
        </div>
      </transition>
    </div>
    <!-- 底部的控制按钮 -->
    <div
      :class="isPack ? 'controlListPack' : 'controlListExtent'"
      v-if="pointOpenItem.userId && helmetType !== 0 && !pointOpenItem.noBindDevice && helmetType !== 4"
      v-show="isPlayTrack"
    >
      <!-- 灯光 控制按钮 -->
      <div
        class="flexColumn"
        v-if="IsZFY === false"
        :class="[
          formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
          IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
        ]"
      >
        <img
          src="@/icon/new-command/status/light.png"
          alt=""
          v-if="
            formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].LED !== '0'
          "
          @click="_LED"
          class="cursor"
        />
        <span v-else>
          <img
            src="@/icon/re-new-command/status/light_off.png"
            alt=""
            v-if="formatDataItem.onlineStatus === '0'"
            @click="_LED"
            class="cursor"
          />
          <img src="@/icon/new-command/status/light_off.png" alt="" v-else @click="_LED" class="cursor" />
        </span>
        <span
          class="mt5 monitor-text"
          :class="
            formatDataItem.onlineStatus !== '0' &&
            helmetStatusObj[formatDataItem.deviceName] &&
            helmetStatusObj[formatDataItem.deviceName].LED !== '0'
              ? 'open-text'
              : ''
          "
          >{{ $t('lighting') }}
          <i
            v-if="formatDataItem.specType !== '0' && formatDataItem.specType !== '3'"
            class="ml5"
            :class="[ledDetailVisible ? 'arrow_up' : 'arrow_up_rotate']"
            @click.stop="showLEDDetail"
          ></i>
        </span>
        <div v-if="ledDetailVisible" class="flex_just_around led_block" @click.stop="">
          <div class="flex_align_center item">
            <span class="pan_label">{{ $t('lightRank') }}：</span>
            <el-select
              v-model="ledRank"
              :placeholder="$t('peaseSelect')"
              style="width: 100px"
              size="mini"
              @change="_settingLEDRank"
            >
              <el-option key="1" :label="'1'+ $t('level')" value="1"></el-option>
              <el-option key="2" :label="'2'+ $t('level')" value="2"></el-option>
              <el-option key="3" :label="'3'+ $t('level')" value="3"></el-option>
              <el-option key="4" :label="'4'+ $t('level')" value="4"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- 摄像 控制按钮 -->
      <div
        class="flexColumn"
        v-if="IsZFY === false"
        :class="[
          formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
          IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
        ]"
      >
        <img
          src="@/icon/new-command/status/recording.png"
          alt=""
          v-if="
            formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].vidicon !== '0'
          "
          @click="_vidicon"
          class="cursor"
        />
        <span v-else>
          <img
            src="@/icon/re-new-command/status/recording_off.png"
            alt=""
            v-if="formatDataItem.onlineStatus === '0'"
            @click="_vidicon"
            class="cursor"
          />
          <img src="@/icon/new-command/status/recording_off.png" alt="" v-else @click="_vidicon" class="cursor" />
        </span>

        <div
          class="mt5 monitor-text"
          :class="
            formatDataItem.onlineStatus !== '0' &&
            helmetStatusObj[formatDataItem.deviceName] &&
            helmetStatusObj[formatDataItem.deviceName].vidicon !== '0'
              ? 'open-text'
              : ''
          "
        >
          {{ $t('Camera')
          }}<i
            class="ml5"
            :class="[vidiconDetailVisible ? 'arrow_up' : 'arrow_up_rotate']"
            @click.stop="showVidiconDetail"
          ></i>
        </div>
        <div v-if="vidiconDetailVisible" class=" flex_just_around vidicon_block" @click.stop="">
          <div class="flex_align_center item">
            <span class="pan_label">{{ $t('Clewtone') }}：</span>
            <el-switch v-model="vidiconObj.isVoiceOpen" active-color="#0E65DD" inactive-color="#E4EAF2"> </el-switch>
          </div>
          <div class="flex_align_center item">
            <span class="pan_label">{{ $t('resolvingPower') }}：</span>
            <el-select v-model="vidiconObj.resolutionHeight" :placeholder="$t('peaseSelect')" style="width: 100px" size="mini">
              <el-option v-for="item in resolutionOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="flex_align_center item">
            <span class="pan_label">{{ $t('Frames') }}：</span>
            <el-select v-model="vidiconObj.frame" :placeholder="$t('peaseSelect')" style="width: 100px" size="mini">
              <el-option v-for="item in frameNumOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- 实时视频 控制按钮，非 国标智能安全帽设备 展示 -->
      <div
        v-if="formatDataItem.specType !== 3"
        class="flexColumn"
        :class="[formatDataItem.onlineStatus === '0' ? 'isOffLine' : '']"
      >
        <img
          src="@/icon/new-command/status/realVideo.png"
          v-if="formatDataItem.onlineStatus !== '0' && realVideoData.serialNumber"
          alt=""
          @click="changePlayVideoVisible(formatDataItem.deviceName, formatDataItem.userName)"
          class="cursor"
        />
        <span v-else>
          <img
            src="@/icon/re-new-command/status/realVideo_off.png"
            alt=""
            v-if="formatDataItem.onlineStatus === '0'"
            @click="changePlayVideoVisible(formatDataItem.deviceName, formatDataItem.userName)"
            class="cursor"
          />
          <img
            src="@/icon/new-command/status/realVideo_off.png"
            alt=""
            v-else
            @click="changePlayVideoVisible(formatDataItem.deviceName, formatDataItem.userName)"
            class="cursor"
          />
        </span>

        <span
          class="mt5 monitor-text"
          :class="formatDataItem.onlineStatus !== '0' && realVideoData.serialNumber ? 'open-text' : ''"
          >{{ $t('realTimeVideo') }}</span
        >
      </div>
      <!-- 视频监控 控制按钮，仅 国标智能安全帽设备 展示 -->
      <div
        v-if="formatDataItem.specType === 3"
        class="flexColumn"
        :class="[formatDataItem.onlineStatus === '0' ? 'isOffLine' : '']"
      >
        <img
          src="@/icon/new-command/status/realVideo.png"
          v-if="formatDataItem.onlineStatus !== '0' && liveVideoProp.serialNumber"
          alt=""
          class="cursor"
          @click="openVideoMonitor()"
        />
        <span v-else>
          <img
            src="@/icon/re-new-command/status/realVideo_off.png"
            alt=""
            v-if="formatDataItem.onlineStatus === '0'"
            class="cursor"
            @click="openVideoMonitor()"
          />
          <img
            src="@/icon/new-command/status/realVideo_off.png"
            alt=""
            v-else
            class="cursor"
            @click="openVideoMonitor()"
          />
        </span>

        <span
          class="mt5 monitor-text"
          :class="formatDataItem.onlineStatus !== '0' && liveVideoProp.serialNumber ? 'open-text' : ''"
          >{{ $t('videoSurveillance') }}</span
        >
      </div>
      <!-- 拍照 控制按钮 -->
      <div
        class="flexColumn"
        v-if="IsZFY === false"
        :class="[
          formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
          IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
        ]"
      >
        <img
          src="@/icon/new-command/status/photo.png"
          alt=""
          v-if="
            formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].photo !== '0'
          "
          @click="_photo"
          class="cursor"
        />
        <span v-else>
          <img
            src="@/icon/re-new-command/status/photo_off.png"
            alt=""
            v-if="formatDataItem.onlineStatus === '0'"
            @click="_photo"
            class="cursor"
          />
          <img src="@/icon/new-command/status/photo_off.png" alt="" v-else @click="_photo" class="cursor" />
        </span>

        <span
          class="mt5 monitor-text"
          :class="
            formatDataItem.onlineStatus !== '0' &&
            helmetStatusObj[formatDataItem.deviceName] &&
            helmetStatusObj[formatDataItem.deviceName].photo !== '0'
              ? 'open-text'
              : ''
          "
          >{{ $t('photograph') }}</span
        >
      </div>
      <!-- 当点击收起时展示一个展开按钮 -->
      <!-- 当点击收起时下列按钮不进行展示 -->
      <template v-if="!isPack">
        <!-- 语音消息 控制按钮 -->
        <div
          class="flexColumn "
          v-if="IsZFY === false"
          :class="[
            formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
            IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
          ]"
        >
          <img
            src="@/icon/new-command/status/broadcast_on.png"
            alt=""
            v-if="showBroadcast"
            @click="switchBroadcast"
            class="cursor"
          />
          <span v-else>
            <img
              src="@/icon/re-new-command/status/broadcast_off.png"
              alt=""
              @click="switchBroadcast"
              v-if="formatDataItem.onlineStatus === '0'"
              class="cursor"
            />
            <img
              src="@/icon/new-command/status/broadcast_off.png"
              alt=""
              v-else
              @click="switchBroadcast"
              class="cursor"
            />
          </span>

          <span class="mt5 monitor-text" :class="showBroadcast ? 'open-text' : ''">{{ $t('VoiceMessage') }}</span>
        </div>
        <!-- GPS 控制按钮 -->
        <div
          class="flexColumn"
          v-if="IsZFY === false"
          :class="[
            formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
            IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
          ]"
        >
          <img
            src="@/icon/new-command/status/GPS.png"
            alt=""
            v-if="
              formatDataItem.onlineStatus !== '0' &&
                helmetStatusObj[formatDataItem.deviceName] &&
                helmetStatusObj[formatDataItem.deviceName].GPS &&
                helmetStatusObj[formatDataItem.deviceName].GPS !== '0'
            "
            @click="_GPS"
            class="cursor"
          />
          <span v-else>
            <img
              src="@/icon/re-new-command/status/GPS_off.png"
              alt=""
              v-if="formatDataItem.onlineStatus === '0'"
              @click="_GPS"
              class="cursor"
            />
            <img src="@/icon/new-command/status/GPS_off.png" alt="" v-else @click="_GPS" class="cursor" />
          </span>

          <span
            class="mt5 monitor-text"
            :class="
              formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].GPS !== '0'
                ? 'open-text'
                : ''
            "
            >{{ $t('GPS_BD') }}</span
          >
        </div>
        <!-- WIFI 控制按钮 -->
        <div
          v-if="pointOpenItem && IsZFY === false"
          class="flexColumn "
          :class="[
            formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
            IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
          ]"
        >
          <span
            :class="
              helmetStatusObj[formatDataItem.deviceName] && helmetStatusObj[formatDataItem.deviceName].WIFI === '-3'
                ? 'forbid-grey'
                : ''
            "
          >
            <img
              src="@/icon/new-command/status/WIFI.png"
              alt=""
              v-if="
                formatDataItem.onlineStatus !== '0' &&
                  helmetStatusObj[formatDataItem.deviceName] &&
                  helmetStatusObj[formatDataItem.deviceName].WIFI !== '0' &&
                  helmetStatusObj[formatDataItem.deviceName].WIFI !== '-1' &&
                  helmetStatusObj[formatDataItem.deviceName].WIFI !== '-2'
              "
              @click="_WIFI"
              :class="helmetStatusObj[formatDataItem.deviceName].WIFI !== '-3' ? 'cursor' : ''"
            />
            <span v-else>
              <img
                src="@/icon/re-new-command/status/WIFI_off.png"
                alt=""
                v-if="formatDataItem.onlineStatus === '0'"
                @click="_WIFI"
                class="cursor"
              />
              <img src="@/icon/new-command/status/WIFI_off.png" alt="" v-else @click="_WIFI" class="cursor" />
            </span>
          </span>
          <span
            class="mt5 monitor-text"
            :class="[
              helmetStatusObj[formatDataItem.deviceName] && helmetStatusObj[formatDataItem.deviceName].WIFI === '-3'
                ? 'grey'
                : '',
              formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].WIFI !== '0'
                ? 'open-text'
                : '',
            ]"
            >WIFI</span
          >

          <div
            v-if="
              helmetStatusObj[formatDataItem.deviceName] && helmetStatusObj[formatDataItem.deviceName].WIFI === '-2'
            "
            class="status-tip"
          >
            ({{ $t('WiFiNotConnected') }})
          </div>
        </div>
        <!-- 激光 控制按钮 -->
        <div
          class="flexColumn"
          v-if="IsZFY === false"
          :class="[
            formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
            IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
          ]"
        >
          <img
            src="@/icon/new-command/status/laser.png"
            alt=""
            v-if="
              formatDataItem.onlineStatus !== '0' &&
                helmetStatusObj[formatDataItem.deviceName] &&
                helmetStatusObj[formatDataItem.deviceName].laser !== '0'
            "
            @click="_laser"
            class="cursor"
          />
          <span v-else>
            <img
              src="@/icon/re-new-command/status/laser_off.png"
              alt=""
              v-if="formatDataItem.onlineStatus === '0'"
              @click="_laser"
              class="cursor"
            />
            <img src="@/icon/new-command/status/laser_off.png" alt="" v-else @click="_laser" class="cursor" />
          </span>

          <span
            class="mt5 monitor-text"
            :class="
              formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].laser !== '0'
                ? 'open-text'
                : ''
            "
            >{{ $t('laser') }}</span
          >
        </div>
        <!-- 重要视频 控制按钮, 国标智能安全帽屏蔽该功能 -->
        <div
          v-if="pointOpenItem && pointOpenItem.specType !== 3 && IsZFY === false"
          class="flexColumn"
          :class="[
            formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
            IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
          ]"
        >
          <img
            src="@/icon/new-command/status/import.png"
            alt=""
            v-if="
              formatDataItem.onlineStatus !== '0' &&
                helmetStatusObj[formatDataItem.deviceName] &&
                helmetStatusObj[formatDataItem.deviceName].imp !== '0'
            "
            @click="_imp"
            class="cursor"
          />
          <span v-else>
            <img
              src="@/icon/re-new-command/status/import_off.png"
              alt=""
              v-if="formatDataItem.onlineStatus === '0'"
              @click="_imp"
              class="cursor"
            />
            <img src="@/icon/new-command/status/import_off.png" alt="" v-else @click="_imp" class="cursor" />
          </span>

          <span
            class="mt5 monitor-text"
            :class="
              formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].imp !== '0'
                ? 'open-text'
                : ''
            "
            >{{ $t('ImportantVideos') }}</span
          >
        </div>
        <!-- 警示灯 控制按钮 -->
        <div
          class="flexColumn"
          v-if="IsZFY === false"
          :class="[
            formatDataItem.onlineStatus === '0' ? 'isOffLine' : '',
            IsZFY === false ? 'cotrol_icon' : 'cotrol_icon_forbid',
          ]"
        >
          <img
            src="@/icon/new-command/status/warnLight.png"
            alt=""
            v-if="
              formatDataItem.onlineStatus !== '0' &&
                helmetStatusObj[formatDataItem.deviceName] &&
                helmetStatusObj[formatDataItem.deviceName].warnlight !== '0'
            "
            @click="_warnlight"
            class="cursor"
          />
          <span v-else>
            <img
              src="@/icon/re-new-command/status/warnLight_off.png"
              alt=""
              v-if="formatDataItem.onlineStatus === '0'"
              @click="_warnlight"
              class="cursor"
            />
            <img src="@/icon/new-command/status/warnLight_off.png" alt="" v-else @click="_warnlight" class="cursor" />
          </span>

          <div
            class="mt5 monitor-text"
            :class="
              formatDataItem.onlineStatus !== '0' &&
              helmetStatusObj[formatDataItem.deviceName] &&
              helmetStatusObj[formatDataItem.deviceName].warnlight !== '0'
                ? 'open-text'
                : ''
            "
          >
            {{ $t('WarningLight') }}
            <i :class="[warnLightDetailVisible ? 'arrow_up' : 'arrow_up_rotate']" @click.stop="showWarnLightDetail"></i>
          </div>
          <div v-if="warnLightDetailVisible" class="warn_block" @click.stop="">
            <div class="item flex_just_align_center">
              <span class="pan_label">{{ $t('Clewtone') }}：</span>
              <el-switch v-model="warnlightVoice" active-color="#0E65DD" inactive-color="#E4EAF2"> </el-switch>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 实时视频allowClick上下操作栏是否显示-->
    <!-- <div v-if="realVideoData.serialNumber" class="real-video-box">
      <RealVideo
        v-if="rtcType === 'trtc'"
        :device.sync="realVideoData"
        :currentItem="formatDataItem"
        :deviceName="formatDataItem.deviceName"
        :allowClick="allowClick"
        ref="realVideoContr"
        v-drag
      ></RealVideo>
      <RealVideoSrs
        v-else-if="rtcType === 'srs'"
        :device.sync="realVideoData"
        :currentItem="formatDataItem"
        :deviceName="formatDataItem.deviceName"
        :allowClick="allowClick"
        ref="realVideoContr"
        v-drag
      ></RealVideoSrs>
      <RealVideoMediasoup
        v-else-if="rtcType === 'mediasoup'"
        :device.sync="realVideoData"
        :currentItem="formatDataItem"
        :deviceName="formatDataItem.deviceName"
        :allowClick="allowClick"
        ref="realVideoContr"
        v-drag
      ></RealVideoMediasoup>
    </div> -->
    <!-- 视频监控播放窗口 toolClick true:执法仪 "mediasoup"，false：管控3 用于视频工具栏是否显示  -->
    <div v-if="liveVideoProp.serialNumber" class="real-video-box">
      <LiveVideoPlus :deviceProp.sync="liveVideoProp"></LiveVideoPlus>
    </div>
    <!-- 语音消息窗口 -->
    <div
      class="broad-record"
      :class="isPack ? 'open-record' : 'close-record'"
      :style="showOpen ? 'height: 80%' : 'height: 50%'"
      v-if="showBroadcast"
      v-drag
    >
      <voiceMessage
        v-model="showBroadcast"
        :listPlay="[helmetdata]"
        :voiceItem="formatDataItem"
        :showOpen.sync="showOpen"
      ></voiceMessage>
    </div>
  </div>
</template>

<script>
// 依赖组件
import NewTree from '@/components/new-tree/Index.vue'
import NewMenu from '@/views/new-command/NewMenu.vue'
import NewHistory from '@/views/new-command/NewHistory.vue'
import voiceMessage from '@/components/voiceMessage/voiceMessage.vue'
import LiveVideoPlus from '@/views/monitor/live/LiveVideoPlus.vue'
// import RealVideo from '@/views/monitor/index/RealVideo.vue'
// import RealVideoSrs from '@/views/monitor/index/RealVideoSrs.vue'
// import RealVideoMediasoup from '@/views/monitor/index/RealVideoMediasoup.vue'
// 依赖工具
import { gethelmet } from '@/api/helmetManage'
import { onlinePersons, findAlertNum, findMsgByDeviceName, findAlertType } from '@/api/monitor'
import { helmetInfo } from '@/api/log/operation'
import { initSwitch, switchAction, ACTION, videoSetting, ledSetting } from '@/common/websocket/remoteControl'
import { warning, getSession } from '@/api/common'
import { getLocation } from '@/common/map'
import { mapGetters } from 'vuex'
import { creatGK3Socket } from '@/common/websocket/index'
export default {
  props: {
    commanditem: {
      type: Object,
    },
    trackPopupInfo: {
      type: Object,
    },
  },
  data() {
    return {
      // jls轨迹相关
      JlsTrailVisible: false,
      // 使用同一个组件判断不同样式
      newJls: true,
      // 巨灵神设备0，安卓端设备1，执法仪2
      helmetType: null,
      normalPan: true,
      helmetdata: {},
      allowClick: false,
      // 实时视频相 关
      realVideoData: {
        serialNumber: null,
        username: null,
      },
      show: false,
      onlinePersons: null,
      theme: '',
      mapMenuData: {
        warnList: [],
        warnNumb: '',
      },
      isDefault: false,
      isPack: false,
      // 格式化的数据
      formatDataItem: {
        userName: '',
        timestamp: '',
        position: '',
        deviceName: '',
        userId: '',
        onlineStatus: '',
        specType: 0,
      },
      tableData: [],
      battery: '',
      wifi: '',
      pressure: '',
      envTemp: '',
      laser: '',
      gps: '',
      mobile: '',
      flash: '',
      cam: '',
      // led展开flag
      ledDetailVisible: false,
      // 摄像展开flag
      vidiconDetailVisible: false,
      // 警告灯展开flag
      warnLightDetailVisible: false,
      // 正在录像flag
      vidiconPlayingFlag: false,
      // 录像提示音等属性对象
      vidiconObj: {
        resolutionHeight: '',
        frame: '',
        isVoiceOpen: '',
      },
      ledRank: '4',
      // 帧数选项
      frameNumOptions: [
        {
          value: 15,
          label: '15',
        },
        {
          value: 20,
          label: '20',
        },
        {
          value: 25,
          label: '25',
        },
      ],
      // 分辨率选项
      resolutionOptions: [
        {
          value: 240,
          label: '240P',
        },
        {
          value: 480,
          label: '480P',
        },
        {
          value: 720,
          label: '720P',
        },
        {
          value: 1080,
          label: '1080P',
        },
      ],
      vidiconObjFlag: true,
      alertTypeList: [],
      findAlertTypeFlag: false,
      onlinePersonsFlag: false,
      findDeviceNamesFlag: false,
      // 设备是否为执法仪
      IsZFY: false,
      // 视频监控入参
      liveVideoProp: {},
      // 展示语音消息功能
      showBroadcast: false,
      // 设备在线状态 、是否显示提示语
      helmetOnline: false,
      showOpen: false,
      helmetData: {},
    }
  },
  components: {
    NewTree,
    NewMenu,
    NewHistory,
    voiceMessage,
    LiveVideoPlus,
    // RealVideo,
    // RealVideoSrs,
    // RealVideoMediasoup,
  },
  computed: {
    ...mapGetters(['rtcType', 'isDefaultTheme']),
    // 语音通话中监听
    waikIngInfo() {
      return this.$store.state.waikeInfo
    },
    // 播放轨迹控制其他组件隐藏
    isPlayTrack() {
      return this.$store.state.isPlayTrack
    },
    helmetStatusObj() {
      return this.$store.state.helmetStatusObj
    },
    // 当前选中设备的状态值
    currentHelmetStatus() {
      if (this.helmetStatusObj && this.helmetStatusObj[this.formatDataItem.deviceName]) {
        return this.helmetStatusObj[this.formatDataItem.deviceName]
      } else {
        return {}
      }
    },
    pointOpenItem() {
      return this.$store.state.currentHelmetData
    },
    getTheme() {
      return this.$store.state.theme
    },
    warnlightVoice: {
      get() {
        if (JSON.stringify(this.helmetStatusObj) !== '{}') {
          return this.helmetStatusObj[this.formatDataItem.deviceName].warnlightVoice === '1'
        } else {
          return false
        }
      },
      set(val) {
        if (val) {
          switchAction(
            this.formatDataItem.deviceName,
            ACTION.WARNLIGHT__VOICE_OPEN,
            this.formatDataItem.userId,
            this.formatDataItem.userName
          )
        } else {
          switchAction(
            this.formatDataItem.deviceName,
            ACTION.WARNLIGHT_VOICE_CLOSE,
            this.formatDataItem.userId,
            this.formatDataItem.userName
          )
        }
      },
    },
    helpInfo() {
      return this.$store.state.helpInfo
    },
    jlsTrackList() {
      return this.$store.state.jlsTrackList
    },
    // realVideoData
    realVideoShow() {
      return this.$store.state.openRealeVideo
    },
  },
  mounted() {
    this.show = true
    this._onlinePersons()
    this._findAlertType()
    // 轮询刷新在线状态
    this.pollInterval = setInterval(() => {
      if (this.findAlertTypeFlag && getSession('access_token')) {
        this._findAlertType()
      }
      if (this.onlinePersonsFlag && getSession('access_token')) {
        this._onlinePersons()
      }
    }, 10000)
  },
  methods: {
    openFencePan() {},
    // 关闭地图泡泡
    closePopup() {
      this.$emit('closePopup')
    },
    // 点击jls轨迹弹窗 播放轨迹 按钮事件
    playJlsTrail(data, index) {
      this.$store.commit('ExitJlsTrailData', data)
      this.$store.commit('ExitJlsTrailIndex', index)
      this.$store.commit('jlsPlayTrack', true)
      this.$store.commit('jlsTrackList', false)
    },
    // 关闭历史记录弹窗
    closeHistoryRecord() {
      this.showHistoryRecord = false
    },
    // 关闭jls轨迹弹窗
    closeJlsTrail() {
      this.JlsTrailVisible = false
    },
    // 实时视频按钮显隐
    changePlayVideoVisible(serialNumber, username) {
      if (
        this.helmetStatusObj[this.formatDataItem.deviceName] &&
        this.helmetStatusObj[this.formatDataItem.deviceName].deviceMode === '3'
      ) {
        warning(this.$t('patternMode'))
        return
      }
      if (this.$store.state.openWaike) {
        if (this.waikIngInfo.groupName) {
          warning('[' + this.waikIngInfo.groupName + '] ' + this.$t('VoiceCalling'))
        } else {
          warning(this.$t('VoiceCalling'))
        }
        return
      }
      // 修改求助状态
      this.$store.commit('handleIsEmergency', false)
      console.log(serialNumber, username, this.realVideoData.serialNumber, 'serialNumber, username')
      if (this.realVideoData.serialNumber && serialNumber !== this.realVideoData.serialNumber) {
        this.realVideoData = { serialNumber: null, username: null }
        // 全局实时视频组件数据存储
        this.$store.commit('changeVideoInfo', this.realVideoData)
        this.$store.commit('changeOpenVideo', false)
        this.$store.commit('openVedio', false)
      } else {
        creatGK3Socket()
        this.realVideoData = { serialNumber, username }
        this.$store.commit('changeVideoInfo', this.realVideoData)
        this.$store.commit('changeOpenVideo', true)

        this.$store.commit('openVedio', true)
      }
    },
    // 打开视频监控
    openVideoMonitor() {
      if (
        this.helmetStatusObj[this.formatDataItem.deviceName] &&
        this.helmetStatusObj[this.formatDataItem.deviceName].deviceMode === '3'
      ) {
        warning(this.$t('patternMode'))
        return
      }
      this.liveVideoProp = {
        // 用户名称
        name: this.formatDataItem.userName,
        // 头盔序列号
        serialNumber: this.formatDataItem.deviceName,
        // 设备类型
        specType: this.formatDataItem.specType,
        // 用户id,用于指令操控
        userId: this.formatDataItem.userId,
      }
    },
    // 获取告警类型
    _findAlertType() {
      findAlertType().then(res => {
        this.findAlertTypeFlag = true
        this.alertTypeList = res.data
        this._findAlertNum()
        this.$store.commit('addAlertTypeArr', res.data)
      })
    },
    // 在线人员查询
    _onlinePersons() {
      let params = {
        ouId: '',
      }
      onlinePersons(params).then(res => {
        this.onlinePersonsFlag = true
        if (res.state === 0) {
          for (let item of res.data) {
            if (item.status === '1') {
              this.onlinePersons = item.number
            }
          }
        }
      })
    },

    // 右上角告警弹窗数量
    _findAlertNum() {
      let param = {
        status: 0,
      }
      findAlertNum(param).then(res => {
        this.mapMenuData.warnList = []
        if (res.state === 0) var dataArr = res.data
        if (dataArr) {
          for (let item of dataArr) {
            if (item.alertType === 'total') {
              this.mapMenuData.warnNumb = item.number
            } else {
              for (let itemType of this.alertTypeList) {
                if (item.alertType === itemType.alertCode) {
                  this.mapMenuData.warnList.push({
                    number: item.number,
                    alertName: itemType.alertName,
                  })
                }
              }
            }
          }
        }
      })
    },
    // 点击展开更多操作按钮并收起历史记录/点击收起更多操作按钮并展开历史记录
    handleExtent() {
      this.isPack = !this.isPack
    },
    getHelmetInfo() {
      if (!this.formatDataItem.userId || this.formatDataItem.userId === 'undefined') {
        return
      }
      helmetInfo(this.formatDataItem.userId).then(res => {
        if (res.state === 0 && res.value) {
          this.helmetData = res.value
          this.battery = res.value && res.value.battery ? res.value.battery.split('.')[0] + '%' : ''
          this.wifi = res.value.wifi
          this.envTemp =
            res.value.logExtraDataDto && res.value.logExtraDataDto.envTemp
              ? res.value.logExtraDataDto.envTemp + '℃'
              : '-'
          this.pressure =
            res.value.logExtraDataDto && res.value.logExtraDataDto.pressure
              ? this.formatPressure(res.value.logExtraDataDto.pressure)
              : '-'
          // this.laser = res.value.laser
          // this.gps = res.value.gps
          // this.mobile = res.value.mobile
          // this.flash = res.value.flash
          // this.cam = res.value.cam
        }
      })
    },
    formatPressure(value) {
      let res = (Number(value) / 10).toFixed(1)
      return res
    },
    // 撒点和树点击进来时格式数据
    async formatData(val) {
      if (!val.userName) {
        return
      }
      this.$store.commit('changeVideoItem', {})
      // 隐藏摄像弹窗
      this.vidiconDetailVisible = false
      if (this.$refs.realVideoContr) {
        this.$refs.realVideoContr.close()
      }
      if (val && val.specType) {
        this.allowClick = val.specType === 1 ? false : true
      }
      this.helmetdata = val
      this.formatDataItem.userName = val.userName
      this.formatDataItem.deviceName = val.deviceName
      this.formatDataItem.timestamp = val.timestamp ? val.timestamp : ''
      this.formatDataItem.userId = val.userId
      this.formatDataItem.onlineStatus = val.onlineStatus
      if (val.onlineStatus === '0') {
        this.helmetOnline = true
      } else {
        this.helmetOnline = false
      }
      if (val.position && val.position.lng && val.position.lat) {
        getLocation(val.position.lng, val.position.lat, position => {
          this.formatDataItem.positionName = position
        })
      }
      this.formatDataItem.specType = val.specType
      this.helmetType = val.specType
      if (val.specType === 2) {
        this.IsZFY = true
      } else {
        this.IsZFY = false
      }
      // 设备不为H5 巨灵神头盔
      if (val && (val.specType || val.specType === 0)) {
        if (val.specType !== 0 && val.specType !== 4) {
          // 获取电量信息等
          this.getHelmetInfo()
          // 初始化遥控器信息
          this.initSwitchInfo()
          this.$store.commit('isPlayTrack', true)
        } else if (val.specType === 0) {
          this.$store.commit('isPlayTrack', false)
          this.$store.commit('jlsTrackList', true)
        } else if (val.specType === 4) {
          this.$store.commit('isPlayTrack', true)
        }
      }
      // 告警tableData
      this._findMsgByDeviceName()
      // 保存打开实时视频设备信息
      this.$store.commit('changeVideoItem', this.formatDataItem)
      // 关闭轨迹
      this.$store.commit('updatePlayTrail', false)
      // 关闭语音消息
      this.showBroadcast = false
      // 关闭帽衬轨迹
      this.closeJlsTrail()
      // 不绑定设备用户默认展示历史记录
      if (!!val.noBindDevice) {
        this.isPack = true
      }
    },
    // 弹窗切换告警面板数据
    _findMsgByDeviceName() {
      if (this.formatDataItem.deviceName) {
        findMsgByDeviceName({
          deviceName: this.formatDataItem.deviceName,
        }).then(res => {
          if (res.state === 0) {
            if (res.data.length > 0) {
              this.tableData = res.data
            } else {
              this.tableData = []
            }
            this.$emit('changeTableData', this.tableData)
          }
        })
      }
    },
    // 初始化遥控器信息
    initSwitchInfo() {
      if (this.formatDataItem.deviceName) {
        initSwitch(this.formatDataItem.deviceName)
        let deviceSn = this.formatDataItem['deviceName']
        this.ledRank =
          deviceSn && this.helmetStatusObj[deviceSn] && this.helmetStatusObj[deviceSn]['LEDRank']
            ? parseInt(parseInt(this.helmetStatusObj[deviceSn]['LEDRank']) / 50) + 1
            : 4
        this.ledRank = this.ledRank + ''
        videoSetting(this.formatDataItem.deviceName, { type: 0 })
        this.ledDetailVisible = false
        this.vidiconDetailVisible = false
        this.warnLightDetailVisible = false
      }
    },
    // 点击拍照
    _photo() {
      if (
        this.helmetStatusObj[this.formatDataItem.deviceName] &&
        this.helmetStatusObj[this.formatDataItem.deviceName].deviceMode === '3'
      ) {
        warning(this.$t('patternMode'))
        return
      }
      if (this.helmetStatusObj[this.formatDataItem.deviceName].photo === '0') {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.PHOTO_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      }
    },
    _vidicon() {
      if (
        this.helmetStatusObj[this.formatDataItem.deviceName] &&
        this.helmetStatusObj[this.formatDataItem.deviceName].deviceMode === '3'
      ) {
        warning(this.$t('patternMode'))
        return
      }
      if (this.helmetStatusObj[this.formatDataItem.deviceName].vidicon === '0') {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.VIDICON_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
        this.vidiconPlayingFlag = true
        this.vidiconDetailVisible = false
        this.$emit('update:infoWindowHeight', 200)
      } else {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.VIDICON_CLOSE,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
        this.vidiconPlayingFlag = false
      }
    },
    // 重要视频
    _imp() {

      if (
        this.helmetStatusObj[this.formatDataItem.deviceName] &&
        this.helmetStatusObj[this.formatDataItem.deviceName].deviceMode === '3'
      ) {
        warning(this.$t('patternMode'))
        return
      }
      if (this.helmetStatusObj[this.formatDataItem.deviceName].imp === '0') {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.IMP_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      } else {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.IMP_CLOSE,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      }
    },
    _WIFI() {
      if (this.helmetStatusObj[this.formatDataItem.deviceName].WIFI === '0') {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.WIFI_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      } else {
        this.$confirm(this.$t('ClosingWIFItip'), '', {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          switchAction(
            this.formatDataItem.deviceName,
            ACTION.WIFI_CLOSE,
            this.formatDataItem.userId,
            this.formatDataItem.userName
          )
        })
      }
    },
    _laser() {
      if (this.helmetStatusObj[this.formatDataItem.deviceName].laser === '0') {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.LASER_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      } else {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.LASER_CLOSE,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      }
    },
    _GPS() {
      if (
        this.helmetStatusObj[this.formatDataItem.deviceName] &&
        this.helmetStatusObj[this.formatDataItem.deviceName].GPS &&
        this.helmetStatusObj[this.formatDataItem.deviceName].GPS === '0'
      ) {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.GPS_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      } else {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.GPS_CLOSE,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      }
    },
    _warnlight() {
      if (this.helmetStatusObj[this.formatDataItem.deviceName].warnlight === '0') {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.WARNLIGHT_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      } else {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.WARNLIGHT_CLOSE,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      }
    },
    _LED() {
      if (!this.helmetStatusObj[this.formatDataItem.deviceName]) {
        return
      }
      if (this.helmetStatusObj[this.formatDataItem.deviceName].LED === '0') {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.LED_OPEN,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      } else {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.LED_CLOSE,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      }
      this.ledDetailVisible = false
    },
    _hotPoint() {
      if (this.helmetStatusObj[this.formatDataItem.deviceName].hotPoint === '0') {
        this.$confirm(this.$t('ConfirmOpenHotspot') + '?', '', {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        }).then(() => {
          switchAction(
            this.formatDataItem.deviceName,
            ACTION.HOT_POINT_OPEN,
            this.formatDataItem.userId,
            this.formatDataItem.userName
          )
        })
      } else {
        switchAction(
          this.formatDataItem.deviceName,
          ACTION.HOT_POINT_CLOSE,
          this.formatDataItem.userId,
          this.formatDataItem.userName
        )
      }
    },
    // 警示灯展开
    showWarnLightDetail() {
      this.warnLightDetailVisible = !this.warnLightDetailVisible
      this.vidiconDetailVisible = false
      this.ledDetailVisible = false
    },
    // 录像展开
    showVidiconDetail() {
      if (
        this.helmetStatusObj[this.formatDataItem.deviceName] &&
        this.helmetStatusObj[this.formatDataItem.deviceName].vidicon !== '0'
      ) {
        warning(this.$t('closeRecordingFirst'))
        return
      }
      if (this.vidiconObjFlag) {
        this.vidiconObj = this.$store.state.vidiconObj
      }
      this.vidiconDetailVisible = !this.vidiconDetailVisible
      this.warnLightDetailVisible = false
      this.ledDetailVisible = false
    },
    showLEDDetail() {
      if (this.formatDataItem.onlineStatus === '0') {
        return
      }
      let deviceSn = this.formatDataItem['deviceName']
      this.ledRank =
        deviceSn && this.helmetStatusObj[deviceSn] && this.helmetStatusObj[deviceSn]['LEDRank']
          ? parseInt(parseInt(this.helmetStatusObj[deviceSn]['LEDRank']) / 50) + 1
          : 4
      this.ledRank = this.ledRank + ''
      this.ledDetailVisible = !this.ledDetailVisible
      this.vidiconDetailVisible = false
      this.warnLightDetailVisible = false
    },
    _settingLEDRank() {
      if (this.formatDataItem.onlineStatus === '0') {
        return
      }
      let deviceSn = this.formatDataItem['deviceName']
      let ledRankSetting = 25 + (this.ledRank - 1) * 50
      ledSetting(deviceSn, { type: 34, level: ledRankSetting })
    },
    // 切换语音消息状态
    switchBroadcast() {
      this.showBroadcast = !this.showBroadcast
      if (this.showBroadcast) {
        this.$store.commit('voiceShow', true)
      }
    },
    beforeunloadFn(e) {
      this.$store.commit('changeHelpInfo', {
        serialNumber: null,
        username: null,
        userId: null,
      })
    },
  },
  watch: {
    // 切换主题监听
    getTheme(val) {
      this.theme = val
      if (this.theme === 'default') {
        this.isDefault = true
      } else if (this.theme === 'dark') {
        this.isDefault = false
      }
    },
    commanditem: {
      handler(val) {
        if (this.formatDataItem.userId !== val.userId) {
          this.formatData(val)
        }
      },
      immediate: true,
    },
    // 录像展开对象
    vidiconObj: {
      handler(newval, oldval) {
        if (oldval.state) {
          let resolutionWidth = null
          if (this.vidiconObj.resolutionHeight === 240) {
            resolutionWidth = 320
          } else if (this.vidiconObj.resolutionHeight === 480) {
            resolutionWidth = 640
          } else if (this.vidiconObj.resolutionHeight === 720) {
            resolutionWidth = 1280
          } else if (this.vidiconObj.resolutionHeight === 1080) {
            resolutionWidth = 1920
          }
          videoSetting(this.formatDataItem.deviceName, {
            type: 1,
            resolutionHeight: this.vidiconObj.resolutionHeight,
            frame: this.vidiconObj.frame,
            isVoiceOpen: this.vidiconObj.isVoiceOpen,
            resolutionWidth: resolutionWidth,
          })
          this.vidiconObjFlag = false
        }
      },
      deep: true,
    },
    helpInfo: {
      handler(val) {
        if (val.serialNumber) {
          // 通过求助信息的设备序列号获取设备的类型等数据
          gethelmet({ serialNumber: val.serialNumber }).then(res => {
            if (res.data && res.data.list && res.data.list[0]) {
              let helmetInfo = res.data.list[0]
              if (helmetInfo.specType === 3) {
                // 国标智能安全帽 一键求助 打开视频监控
                this.liveVideoProp = {
                  // 用户名称
                  name: val.username,
                  // 头盔序列号
                  serialNumber: val.serialNumber,
                  // 设备类型
                  specType: helmetInfo.specType,
                  // 用户id,用于指令操控
                  userId: val.userId,
                  // 用于一键求助打开声音
                  helpType: true,
                }
              } else {
                // 其它设备 一键求助 默认打开实时视频
                this.realVideoData = val
                this.$store.commit('changeVideoInfo', this.realVideoData)
                this.$store.commit('changeOpenVideo', true)
              }
            }
          })
        }
      },
      immediate: true,
    },
    jlsTrackList(newVal, oldVal) {
      if (newVal) {
        this.JlsTrailVisible = newVal
      }
    },
    // 点击地图选中设备的信息
    pointOpenItem(newVal, oldVal) {
      this.helmetType = newVal.specType
    },
    realVideoShow: {
      handler(val) {
        if(!val) {
          this.realVideoData = { serialNumber: null, username: null }
        }
      },
      immediate: true,
    },
  },
  beforeCreate() {
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
    this.$store.commit('isPlayTrack', false)
  },
  destroyed() {
    this.closePopup()
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
    clearInterval(this.pollInterval)
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.mainMonitor
  height 101%!important;
  .leftContain
    width 48%
    height: 100%;
    position absolute
    .treeContain
      width 36%
      height calc(100% - 40px)
      margin-top: 20px;
      /deep/.el-tree-node
        border-top: 1px solid var(--tree-border-color) !important;
  .rightContain
    width 40%
    height: 100%;
    position absolute
    right 0px
  .historyContain
    pointer-events: auto
    position absolute
    right: 20px
    top: 20px
    width 120px
    height: 93%
  .isOffLine
    pointer-events none
  .controlListPack
    width 22%
    pointer-events: auto
    position absolute
    bottom: 30px;
    left: 650px;
    display: flex
    justify-content: space-around
    transition: width 0.5s
    .extentBtn
      position: absolute;
      right: -11px;
      top: 8px;
  .arrow_up
    cursor pointer
    width 8px
    height 8px
    display inline-block
    bg-image('~@/icon/arrow_up.png')
  .arrow_up_rotate
    cursor pointer
    transform rotate(180deg)
    width 8px
    height 8px
    display inline-block
    bg-image('~@/icon/arrow_up.png')
  .warn_block
    padding 5px
    border-radius 4px
    border 1px solid #333
    background-color: #fff
    color #333
  .vidicon_block
    position absolute
    bottom 80px
    left 20px
    width 460px
    height 74px
    bg-image('~@/icon/new-command/status/vidicon_default.png')
    >>>.el-input__inner
      width 100px
    >>>.el-input__suffix
      right: 109px;
    .item
      height 60px
      color #333
  .led_block
    position absolute
    bottom 80px
    left 10px
    width 230px
    height 64px
    bg-image('~@/icon/new-command/status/vidicon_default.png')
    >>>.el-input__inner
      width 100px
    >>>.el-input__suffix
      right: 109px;
    .item
      height 60px
      color #333
  .controlListExtent
    width 65%
    pointer-events: auto
    position absolute
    bottom: 30px;
    left: 406px;
    display: flex
    justify-content: space-around
    transition: width 0.5s
  .jlshelmet
    pointer-events: auto
    padding-bottom: 30px
  .real-video-box
    position absolute
    bottom 120px
    left 400px
    width 550px
    height 300px
    pointer-events: auto;
  .broad-record
    position absolute
    top 20px
    bottom 120px
    right 236px
    width 400px
    height 60%
    transition: height .3s ease;
    pointer-events auto
  .open-record
    right 600px
    transition: right .3s ease;
  .close-record
    right 236px
    transition: right .3s ease;
  .cotrol_icon_forbid
    pointer-events none
    cursor url('../../icon/new-monitor/forBiden2.png'),default
.forbid-grey
  -webkit-filter: grayscale(100%)
  -moz-filter: grayscale(100%)
  -ms-filter: grayscale(100%)
  -o-filter: grayscale(100%)
  filter: grayscale(100%)
  filter: gray
  cursor: not-allowed
  pointer-events: none
.grey
  color gray
// 深色样式
.theme-dark
  .warn_block
    background-color: rgba(5,45,132,0.8)
    border 1px solid #00DEFF
    color #fff
  .vidicon_block
    bg-image('~@/icon/new-command/status/vidicon_bg.png')
    .item
      color #fff
  .led_block  
    bg-image('~@/icon/new-command/status/vidicon_bg.png')
    .item
      color #fff
@media screen and (max-width 1440px)
  .mainMonitor
    .jlshelmet
      top: 5%;
      left: 33.5%;
    .helmetStatusOff
      top: 28%;
@media screen and (max-width 1368px)
  .mainMonitor
    .jlshelmet
      top: -1%;
      left: 32.5%;
@media screen and (max-width 1280px)
  .mainMonitor
    .jlshelmet
      top: 1%;
      left: 31%;
    .helmetStatusOff
      top: 26%;
::v-deep.popup-content
  background: var(--mainMonitor-BMap_center);
// 深色模式样式覆盖
.common-blue-contain .el-table{
  height: 238px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
